import { DateTimeEditor } from '@dataGrid/components/cellEditors';

import { withStyles } from "@material-ui/core";

const styles = () => ({
  inputRoot: {
    height: 32,
  },
  dateTimeContainer: {
    margin : 8,
    marginLeft: 16,
  },
});

export default withStyles(styles)(DateTimeEditor);
